module.exports = __webpack_public_path__ + "img/6_107.561b1372.png";